module.exports = __webpack_public_path__ + "ca3decc403ea2c37bca43caf15e11a24.svg";